import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import WhereMovementMatters from "./sections/WhereMovementMatters";
import WelcomeToAlignPhysiotherapy from "./sections/WelcomeToAlignPhysiotherapy";
import OurSpecialisedServices from "./sections/OurSpecialisedServices";
import WhyChooseAlignPhysiotherapy from "./sections/WhyChooseAlignPhysiotherapy";
import MeetOurLeadPhysiotherapist from "./sections/MeetOurLeadPhysiotherapist";
import Testimonials from "./sections/Testimonials";
import ContactUs from "./sections/ContactUs";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <WhereMovementMatters />
      <WelcomeToAlignPhysiotherapy />
      <OurSpecialisedServices />
      <WhyChooseAlignPhysiotherapy />
      <MeetOurLeadPhysiotherapist />
      <Testimonials />
      <ContactUs />
      <Footer />
    </div>;
}